<div
  class="taxi-card"
  [ngClass]="policyClass"
  role="button"
  tabindex="0"
  [attr.aria-label]="selectLabel + ' ' + card.supplierName"
  [attr.aria-disabled]="card.unavailable ? true : null"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  (keydown.space)="onCardClick()"
>
  @if (policyLabel) {
    <span class="visuallyhidden">{{ policyLabel }}</span>
  }
  <div class="taxi-card__header">
    <div class="taxi-card__supplier-block">
      <span class="taxi-card__supplier">{{ card.supplierName }}</span>
      @if (card.vehicleType) {
        <span class="taxi-card__vehicle">{{ card.vehicleType }}</span>
      }
    </div>

    <div class="taxi-card__price-block">
      <span class="taxi-card__price-label" i18n="@@chatTaxiTotalPrice">Total Price</span>
      <span class="taxi-card__price">{{ formattedPrice }}</span>
      <!-- Policy indicator: same component/tooltip as the results page,
           placed under the headline price per the travel-policy spec. -->
      <app-warning-tags
        [ticket]="headlineWarningTicket"
        [displayCheck]="false"
        (click)="$event.stopPropagation()"
      ></app-warning-tags>
    </div>
  </div>

  <div class="taxi-card__route">
    <span class="taxi-card__location taxi-card__location--from">{{ card.fromLocation }}</span>
    <span class="taxi-card__arrow">→</span>
    <span class="taxi-card__location taxi-card__location--to">{{ card.toLocation }}</span>
  </div>

  <div class="taxi-card__datetime">
    @if (card.departDate) {
      <span class="taxi-card__date">{{ card.departDate }}</span>
    }
    @if (card.departDate && card.departTime) {
      <span class="taxi-card__separator">·</span>
    }
    @if (card.departTime) {
      <span class="taxi-card__time">{{ card.departTime }}</span>
    }
    @if (durationLabel) {
      <span class="taxi-card__separator">·</span>
      <span class="taxi-card__duration">{{ durationLabel }}</span>
    }
  </div>
</div>
